import React, { useEffect, useState } from 'react';
import styles from './linkfooter.module.css';
import totvsLogo from './totvs-logo.png';
import totvsLogoWhite from './totvs-logo-white.png';

const LinkFooter = () => {
    const [isDarkTheme, setIsDarkTheme] = useState(false);

    useEffect(() => {
        const queryParam = new URLSearchParams(window.location.search);
        const theme = queryParam.get('theme');
        setIsDarkTheme(theme === 'dark');
    }, []);

    return (
        <div className={styles.linkfooter}>
            <h1 className={styles.mainTitle}>LINKS IMPORTANTES:</h1>
            
            <div className={styles.links}>
                <div className={styles.link}>
                    <a target="_placeholder" rel="noopener noreferrer" href="https://tdn.totvs.com/pages/releaseview.action?pageId=945408020" className={styles.linkText}>Central do Cliente Reforma Tributária</a>
                </div>
                <div className={styles.link}>
                    <a target="_placeholder" rel="noopener noreferrer" href="https://espacolegislacao.totvs.com/reforma-tributaria/" className={styles.linkText}>Espaço Legislação TOTVS</a>
                </div>
                <div className={styles.link}>
                    <a target="_placeholder" rel="noopener noreferrer" href="https://espacolegislacao.totvs.com/protheus-reforma-tributaria/" className={styles.linkText}>Reforma Tributária Protheus</a>
                </div>
                <div className={styles.link}>
                    <a target="_placeholder" rel="noopener noreferrer" href="https://produtos.totvs.com/ficha-tecnica/tudo-sobre-o-totvs-inteligencia-tributaria/" className={styles.linkText}>TOTVS Inteligência Tributária</a>
                </div>
                <div className={styles.link}>
                    <a target="_placeholder" rel="noopener noreferrer" href="https://www.gov.br/fazenda/pt-br/acesso-a-informacao/acoes-e-programas/reforma-tributaria" className={styles.linkText}>Portal Nacional da Reforma Tributária</a>
                </div>
            </div>
            
            <img src={isDarkTheme ? totvsLogoWhite : totvsLogo} alt="TOTVS Logo" className={styles.logo} />
        </div>
    );
};

export default LinkFooter;
